import React from 'react'
import SectionTitle from 'app/views/components/Headers&Text/SectionTitle'
import MainTable from 'app/views/components/Table/MainTable'
import { LoanParams } from 'app/models/loan-params'
import { columnDefs } from './loans-page-coumnDefs'
import LoanDetailPanel from './loan-detail-panel'
import {
  GridSortingStorage,
  GridPaginationStorage,
  GridColumnVisibilityStorage,
  useGridSorting,
  useGridPagination,
  useGridColumnVisibility,
} from 'app/utils/grid-sorting-storage'


interface ExpandableMantineTableProps {
  loans: LoanParams[]
  globalLoading: boolean
  title?: string
  setSelectedBulkLoans: React.Dispatch<React.SetStateAction<LoanParams[]>>
  tableSelectedRows: Record<string, boolean>
  setTableSelectedRows: React.Dispatch<
    React.SetStateAction<Record<string, boolean>>
  >
}

const ExpandableMantineTable: React.FC<ExpandableMantineTableProps> = ({
  loans,
  globalLoading,
  title,
  setSelectedBulkLoans,
  tableSelectedRows,
  setTableSelectedRows,
}) => {
  const [isInactiveLoan, setIsInactiveLoan] = React.useState(false)

  // Grid preferences hooks
  const { sorting, handleSortingChange } = useGridSorting(
    GridSortingStorage.facilityLoans,
  )
  const { pagination, handlePaginationChange } = useGridPagination(
    GridPaginationStorage.facilityLoans,
  )
  const { columnVisibility, handleColumnVisibilityChange } =
    useGridColumnVisibility(GridColumnVisibilityStorage.facilityLoans)

  const handleToggle = (isActive: boolean) => {
    setIsInactiveLoan(isActive)
  }

  const filteredLoans = React.useMemo(() => {
    if (isInactiveLoan) {
      return loans.filter((loan) => loan.status === 'Locked')
    }
    return loans.filter((loan) => loan.status !== 'Locked')
  }, [loans, isInactiveLoan])

  const renderDetailPanel = (row: {
    original: LoanParams
    getIsExpanded: () => boolean
  }) => <LoanDetailPanel row={row.original} isExpanded={row.getIsExpanded()} />

  const handleRowSelection = (selectedRows: LoanParams[]) => {
    setSelectedBulkLoans(selectedRows)
  }

  return (
    <>
      {title && <SectionTitle>{title}</SectionTitle>}
      {columnDefs.length != 0 ? (
        <MainTable
          tableName={title ?? ''}
          columnDefs={columnDefs}
          withPagination={true}
          data={filteredLoans ?? []}
          initialSorting={[
            { id: sorting.sortBy, desc: sorting.order === 'desc' },
          ]}
          onSortingChange={handleSortingChange}
          initialPagination={pagination}
          onPaginationChange={handlePaginationChange}
          initialColumnVisibility={columnVisibility}
          onColumnVisibilityChange={handleColumnVisibilityChange}
          setRow={() => { }}
          renderDetailPanel={({ row }) => renderDetailPanel(row)}
          csvExportEnabled
          enableTopToolbar={false}
          headerBackgroundColor="#F0EEEE"
          isLoading={globalLoading}
          isAccordionTable={true}
          showBottomBoolean={true}
          isInactiveLoanLocs={isInactiveLoan}
          onToggle={(isActive) => handleToggle(isActive)}
          border={true}
          controlSectionBorder={false}
          enableMultiRowSelection={true}
          enableRowSelection={true}
          tableSelectedRows={tableSelectedRows}
          setTableSelectedRows={setTableSelectedRows}
          selectedRows={handleRowSelection}
        />
      ) : null}
    </>
  )
}


export default ExpandableMantineTable;

